import { http } from "../../../http-common";
import { Ticket, TicketCreateUpdate, TicketResponse, TicketResponseCreateUpdate, TicketStats } from "./../Type/Ticket";

export const getTickets = async (parametre: any): Promise<Ticket[]> => {
  const response = await http.get<Ticket[]>(`/accounts/me/tickets${parametre}`);
  return response.data;
};


export const TicketService = {
  getTicketStats: async (): Promise<TicketStats> => {
    const response = await http.get<TicketStats>("/tickets/stats");
    return response.data;
  },
};

export const getAllTickets = async (parametre: any): Promise<Ticket[]> => {
  const response = await http.get<Ticket[]>(`/tickets${parametre}`);
  return response.data;
};

export const getTicketAttachment = async (id: number): Promise<any> => {
  const response = await http.get<Ticket[]>(`/ticket-attachments/${id}`);
  return response.data;
};
export const getTicketResponseAttachment = async (id: number): Promise<any> => {
  const response = await http.get<Ticket[]>(`/ticket-response-attachments/${id}`);
  return response.data;
};

export const getTicketDetails = async (id: number): Promise<Ticket> => {
  const response = await http.get<Ticket>(`/tickets/${id}`);
  return response.data;
};

export const createTicket = async (ticket: TicketCreateUpdate): Promise<number> => {
  const response = await http.post<number>('/accounts/me/tickets', ticket);
  return response.data;
};

export const updateTicket = async (id: number, ticket: any): Promise<Ticket> => {
  const response = await http.patch<Ticket>(`/tickets/${id}`, ticket);
  return response.data;
};

export const deleteTicket = async (id: number): Promise<void> => {
  await http.delete<void>(`/tickets/${id}`);
};

// Ticket Response Services
export const getTicketResponses = async (ticketId: number): Promise<TicketResponse[]> => {
  const response = await http.get<TicketResponse[]>(`/accounts/me/tickets/${ticketId}/ticket-responses/all`);
  return response.data;
};

export const createTicketResponse = async (ticketId: number, response: TicketResponseCreateUpdate): Promise<TicketResponse> => {
  const httpResponse = await http.post<TicketResponse>(`/accounts/me/tickets/${ticketId}/ticket-responses`, response);
  return httpResponse.data;
};

export const updateTicketResponse = async (id: number, response: TicketResponseCreateUpdate): Promise<TicketResponse> => {
  const httpResponse = await http.put<TicketResponse>(`/ticket-responses/${id}`, response);
  return httpResponse.data;
};

export const deleteTicketResponse = async (id: number): Promise<void> => {
  await http.delete<void>(`/ticket-responses/${id}`);
};

export const uploadTicketAttachment = async (ticketId: number, file: File): Promise<void> => {
  const formData = new FormData();
  formData.append('file', file);
  await http.post(`/tickets/${ticketId}/attachments`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const uploadTicketResponseAttachment = async (ticketResponseId: number, file: File): Promise<void> => {
  const formData = new FormData();
  formData.append('file', file);
  await http.post(`/ticket-responses/${ticketResponseId}/attachments`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const deleteTicketAttachment = async (id: number): Promise<void> => {
  await http.delete<void>(`/ticket-attachments/${id}`);
};